export * as Api from './api';
export var WithdrawalStatus;
(function (WithdrawalStatus) {
    WithdrawalStatus["Requested"] = "REQUESTED";
    WithdrawalStatus["ExportedToCustodian"] = "EXPORTED_TO_CUSTODIAN";
    WithdrawalStatus["Rejected"] = "REJECTED";
    WithdrawalStatus["BulkUploaded"] = "BULK_UPLOADED";
})(WithdrawalStatus || (WithdrawalStatus = {}));
export var WithdrawalRequestSource;
(function (WithdrawalRequestSource) {
    WithdrawalRequestSource["Investor"] = "INVESTOR";
    WithdrawalRequestSource["AdminSite"] = "ADMIN_SITE";
})(WithdrawalRequestSource || (WithdrawalRequestSource = {}));
export var WithdrawalExportStatus;
(function (WithdrawalExportStatus) {
    WithdrawalExportStatus["AwaitingCustodianExport"] = "AwaitingCustodianExport";
    WithdrawalExportStatus["ExportedToCustodian"] = "ExportedToCustodian";
})(WithdrawalExportStatus || (WithdrawalExportStatus = {}));
//# sourceMappingURL=index.js.map